export default "__VITE_ASSET__CFo3y$c2__"